import { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { getMe, postMe } from '../../utils/api';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Loading from '../loading';

const Profile = () => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently().then((token) => setAccessToken(token));
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    if (!isLoading && accessToken) {
      getMe(accessToken).then((data) => {
        if (data && data.name) {
          setName(data.name);
        }
      })
      .catch((error) => {
        console.warn(error);
        setError(error.toString());
      });
    }
  }, [isLoading, accessToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(null);

    try {
      await postMe(accessToken, name);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err.toString());
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box sx={{ maxWidth: '400px', margin: '0 auto' }}>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
          required
          disabled={loading}
        />
        
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Save Name'}
        </Button>

        {success && (
          <Alert severity="success" sx={{ mt: 2 }}>
            Name updated successfully!
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </form>
    </Box>
  );
};

export default Profile;
